






































import $ from 'jquery';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { EnumComponentType } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { UIPage } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIPage';
import { UIPageGroup } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIPageGroup';
import { ViewObject } from '@/api/com/MetaPattern/MDA/MD/UIModel/ViewObject';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { TreeNode } from '@/libs/com/MetaPattern/Product/IDE/Util/TreeNode';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Warning from '@/components/page/Warning.vue';
import PageScope from '@/components/common/PageScope.vue';
import ViewObjectEditor from '@/components/designer/ViewObjectEditor.vue';
import UIPageEditor from '@/components/designer/UIPageEditor.vue';
import UIPageGroupEditor from '@/components/designer/UIPageGroupEditor.vue';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { MDRepository } from '@/libs/com/MetaPattern/MDA/MD/MDRepository';
import { Tree } from 'element-ui';

@Component({
  components: {
    Warning,
    PageScope,
    ViewObjectEditor,
    UIPageEditor,
    UIPageGroupEditor
  }
})
export default class UIModel extends Vue {
  @Prop() appId!: string; // 应用ID
  @Prop() productId!: string; // 产品ID
  @Prop() comId!: string;
  @Prop() designId!: string; // 当前组件的设计期ID
  private key = 0;
  private trees: Array<TreeNode<BaseElement>>;
  private h2Title: string; // 页面内二级标题
  private viewObject: ViewObject; // 选中的视图对象
  private page: UIPage; // 选中的页面
  private pageGroup: UIPageGroup; // 选中的页面分组
  private curComponent: UIModelComponent; // 当前操作的UI模型对组件
  expandedList: string[] = [];

  constructor() {
    super();
    this.h2Title = '';
    this.viewObject = null;
    this.page = null;
    this.pageGroup = null;
    this.trees = null;
    this.curComponent = null;
  }

  created() {
    EventBus.$on('pgValueChanged', (name: string, newValue: any) => {
      if (!this.isCurrentDoc()) return;
      const component = this.$store.state.ModuleMD.curComponent;
      if (component !== null && component instanceof UIModelComponent) {
        component.modify();
      }
    });
    // 工具条菜单命令
    EventBus.$on('tool:command', (command: string) => {
      // 保存当前组件
      if (command === 'save') {
        if (this.$store.state.ModuleMD.curComponent.designId === this.curComponent.designId) {
          this.saveComponent(this.$store.state.ModuleMD.curComponent);
        }
      } else if (command === 'saveAll') {
        if (this.curComponent.persistenceStatus !== EnumPersistenceStatus.None) {
          this.saveComponent(this.curComponent);
        }
      }
    });
    /** 重做、恢复的键盘事件 */
    $(document).on('keydown', e => {
      // 只有当前文档相应快捷键
      if (!this.isCurrentDoc()) return;
      if (e.ctrlKey === true) {
        switch (e.key) {
          case 's':
            /* Ctrl + S 保存 */
            this.saveComponent(this.curComponent);
            e.stopPropagation();
            e.preventDefault();
            break;
          default:
            break;
        }
      }
    });
  }

  /* 更新前设置扩展的节点，重新渲染即可选中。如果在点击事件中操作，则导致每次点击都会出发重新渲染树 */
  beforeUpdate(): void {
    if (this.$store.state.ModuleMD.curMDDesignId !== '') {
      this.expandedList = [];
      this.expandedList.push(this.$store.state.ModuleMD.curMDDesignId);
    }
    // console.log('APPInfo : beforeUpdate');
  }

  /* 数据更新后，设置当前高亮的节点 */
  updated(): void {
    if (this.$store.state.ModuleMD.curMDDesignId !== '') {
      (this.$refs.tree as Tree).setCurrentKey(this.$store.state.ModuleMD.curMDDesignId);
    }
    // console.log('APPInfo : updated');
  }

  /** 加载中 */
  loading(): boolean {
    return this.curComponent === null;
  }

  /** 检测是否操作的是当前的文档，所有的事件相应都应该先做此判断 */
  isCurrentDoc() {
    if (!this.curComponent || this.curComponent === null || this.$store.state.ModuleMD.curComponent === null || this.curComponent.designId !== this.$store.state.ModuleMD.curComponent.designId) {
      return false;
    }
    return true;
  }

  beforeDestroy() {
    EventBus.$off('pgValueChanged');
  }

  get defaultProps() {
    return {
      children: 'children',
      label: 'label',
      id: 'id',
      isLeaf: 'isLeaf'
    };
  }

  get treeData() {
    if (this.trees === null) {
      if (this.designId) {
        MDExtendService.GetFullComponentAsync(this.designId, EnumComponentType.UIModel)
          .then((component: BaseComponent) => {
            // this.trees = this.BuildTree(component as UIModelComponent);
            this.curComponent = component as UIModelComponent;
            this.$store.dispatch('ModuleMD/setUIModelComponentAction', component);
            this.$store.dispatch('ModuleMD/setCurComponentAction', component);
          });
      }
    }
    if (this.curComponent !== null) {
      this.trees = this.BuildTree(this.curComponent);
    } else {
      this.trees = new Array<TreeNode<BaseElement>>();
    }
    return this.trees;
  }

  get refreshKey() {
    return this.key;
  }

  BuildTree(component: UIModelComponent) {
    const trees = new Array<TreeNode<BaseElement>>();
    const customPageGroupsNode = new TreeNode<BaseElement>('CustomPage', '自定义页面', '', false, null);
    const pageGroupsNode = new TreeNode<BaseElement>('EntityPage', '生成页面', '', false, null);
    component.pageGroups.forEach((item: UIPageGroup) => {
      const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}`, item.name, true, item);
      if (item.bindingCode === '') {
        customPageGroupsNode.addChild(itemNode);
      } else {
        item.pages.forEach((page: UIPage) => {
          itemNode.addChild(new TreeNode<BaseElement>(page.designId, `${page.name}`, page.name, true, page));
        });
        pageGroupsNode.addChild(itemNode);
      }
    });
    trees.push(customPageGroupsNode);
    trees.push(pageGroupsNode);

    const viewObjectsNode = new TreeNode<BaseElement>('ViewObject', '视图对象', '', false, null);
    component.viewObjects.forEach((item: ViewObject) => {
      MDExtendService.setElementListSequence(item.attributes, false);
      const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}`, item.name, true, item);
      viewObjectsNode.addChild(itemNode);
    });
    trees.push(viewObjectsNode);
    return trees;
  }

  /** 树节点选中的事件处理 */
  handleNodeClick(node: TreeNode<BaseElement>): void {
    if (node.data) {
      const element = node.data;
      if (element instanceof BaseElement) {
        this.h2Title = '';
        this.viewObject = null;
        this.page = null;
        this.pageGroup = null;
        if (element instanceof ViewObject) {
          this.viewObject = element;
          this.h2Title = `${element.name} （${element.displayName}）`;
        } else if (element instanceof UIPage) {
          this.page = element;
          this.h2Title = `${element.name} （${element.displayName}）`;
        } else if (element instanceof UIPageGroup && element.bindingCode === '') {
          this.pageGroup = element;
          this.h2Title = `${element.name} （${element.displayName}）`;
        }
        this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', element.designId);
        this.$store.dispatch('ModuleMD/setCurMDElementAction', { element: element });
      }
    }
  }

  /** 保存UI模型 */
  saveComponent(component: UIModelComponent) {
    if (component.persistenceStatus !== EnumPersistenceStatus.None) {
      const deleteDesignIds = new Array<string>();
      MDExtendService.SaveComponentAsync(component, deleteDesignIds)
        .then((response) => {
          this.output(`组件 [${component.displayName}] 界面模型保存成功。`);
          this.$message({ type: 'success', message: `组件 [${component.displayName}] 界面模型保存成功。` });
        })
        .catch((exp) => {
          this.output(`组件 [${component.displayName}] 界面模型保存失败，失败原因：${exp}。`);
        });
    }
  }

  /** 添加自定义页面分组 */
  addCustomPageGroup(node: any, evt: any) {
    const group = MDRepository.createUIPageGroup(this.curComponent);
    this.curComponent.modify();
    const groupNode = new TreeNode<BaseElement>(group.designId, `${group.name}`, group.name, true, group);
    node.addChild(groupNode);
    this.key++;
    this.$store.dispatch('ModuleMD/setElementAction', { element: group, componentDesignId: this.curComponent.designId });
    evt.stopPropagation();
    evt.preventDefault();
  }

  hasModified(data: any) {
    let persistenceStatus: EnumPersistenceStatus;
    if (!data) {
      return false;
    }
    if (data instanceof BaseElement) {
      persistenceStatus = data.persistenceStatus;
    }
    return persistenceStatus !== EnumPersistenceStatus.None;
  }

  output(message: string) {
    this.$store.dispatch('ModuleMD/setOutputMessagesAction', message);
  }
}
